module.exports = __webpack_public_path__ + "da6f2614abf68c6a278f5752592ca35a.png";